import { Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'app-select-wrapper',
	templateUrl: 'select-wrapper.component.html',
	styleUrls: ['select-wrapper.component.scss']
})
export class SelectWrapperComponent {}
